<template>
  <div class="text-center">
    <div class="countdown" style="white-space: nowrap">
      <span class="hours badge badge-light">{{ remaining.hours | zerofill }}</span> : 
      <span class="minutes badge badge-light">{{remaining.minutes | zerofill }}</span> : 
      <span class="seconds badge badge-light">{{ remaining.seconds | zerofill }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

Vue.filter('zerofill', function (value) {
  if(!value) return '00';
  return ( value < 10 && value > -1 ? '0' : '' ) + value;
});

export default {
  props: ["end", "stop"],


  computed: {
    timestamp() {
      return this.$store.state.time.getTime();
    },

    endTimestamp() {
      if(!this.end) return 0;

      return Date.parse(this.end);
    },

    remaining() {
      if(this.stop) return 0;
      
      let diff = this.endTimestamp - this.timestamp;
      if(diff < 0) { 
        return {}
      } 

      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60),
        milliseconds: diff
      };
    }
  }
};
</script>

<style scoped>
.countdown {
  font-size: 16px;
  font-size: 11vw;
}

.countdown .badge {
  /* font-weight: lighter; */
  opacity: .8;
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/Countdown.vue